<template>
	<el-dialog
		title="提示"
		:visible.sync="dialogVisible"
		class="approveDialogWrap"
		width="30%"
	>
		<div>
			确定要取消审批？
		</div>
		<div class="backWrap">
			<div class="label">
				退回节点
			</div>
			<div class="content">
				<el-select placeholder="选择退回节点" v-model="backType">
					<el-option
						v-for="item in backTypeList"
						:key="item.value"
						:label="item.label"
						:value="item.value"
					></el-option>
				</el-select>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="info" @click="dialogVisible = false"
				>取 消</el-button
			>
			<el-button type="primary" @click="handleConfirm">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { backApproveProcessApi } from "../../../services/workbenchServices";

export default {
	name: "dialog",
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		itemId: {
			type: String,
		},
		type: {
			type: String,
		},
	},
	data() {
		return {
			backType: "",
			backTypeList: [
				{ label: "开始节点", value: "FIRST_STEP" },
				{ label: "上一节点", value: "LAST_STEP" },
			],
		};
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.backType = "";
				this.$emit("updateVisible", { val });
			},
		},
	},
	methods: {
		handleConfirm() {
			if (!this.backType) {
				this.$message.warning("请选择退回节点");
				return;
			}
			const params = {
				backType: this.backType,
				itemId: this.itemId, //对应审批对象的id
				type: this.type,
			};
			backApproveProcessApi(params)
				.then((res) => {
					if (res.code == 10000000) {
						this.$message.success("取消审批成功");
						this.$emit("updateVisible", {
							val: false,
							isQuery: true,
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message.error("网络请求失败");
				});
		},
	},
};
</script>

<style scoped lang="scss">
.approveDialogWrap {
	.backWrap {
		display: flex;
		margin: 10px 0;
		align-items: center;

		.label {
			width: 60px;
		}

		.content {
			flex: 1;
		}
	}

	.dialog-footer {
		text-align: center;
		width: 100%;
		display: inline-block;
	}
}
</style>
